import { render, staticRenderFns } from "./UsageChartLatestMonth.vue?vue&type=template&id=495d0fe9"
import script from "./UsageChartLatestMonth.vue?vue&type=script&lang=js"
export * from "./UsageChartLatestMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports